import { render, staticRenderFns } from "./ThgBillingSelectionItemPartnerContactData.vue?vue&type=template&id=0f0999ac&"
import script from "./ThgBillingSelectionItemPartnerContactData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemPartnerContactData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSkeletonLoader,VTextField})
